// extracted by mini-css-extract-plugin
export default {"fullWidth":"hn-z","image":"in-z","lazyLoadPicture":"jn-z","lazyLoadSpinner":"kn-z","lazyLoadSpin":"ln-z","lazyLoadImage":"mn-z","hasStyledAspectRatio":"nn-z"};